import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { createAccrualsSlice } from './accruals-slice';
import { createFacilityCoreSlice } from './facility-core-slice';
import { FacilityStore } from './facility-types';
import { createMasterScheduleSlice } from './master-schedule-slice';

export const useFacilityStore = create<FacilityStore>()(
  devtools(
    persist(
      (...args) => ({
        ...createFacilityCoreSlice(...args),
        ...createMasterScheduleSlice(...args),
        ...createAccrualsSlice(...args),
      }),
      { name: 'facility-store' }
    )
  )
);
